import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import Webhook from 'app/models/webhook';

export default Base.extend({
  model: Webhook,
  url: appUrl('webhooks'),

  initialize(models, options) {
    this.apiMode = options.apiMode;
  },

  parse(response) {
    return response.webhooks;
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/webhooks.js